/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { ResetReason } from '@/task-manager/entities/reset-reason';
import type { TaskDetails } from '@/task-manager/entities/task-details';

import { type BodyOf, tasksV1CardsResetScoreCreate } from '../fetch-client';
import { resetReasonMapper } from '../mappers/reset-reason';
import { useFetchOpts } from '../use-fetch-opts';

export namespace ResetScore {
  export type Input = {
    taskId: TaskDetails['id'];
    reason: ResetReason;
    description: string;
  };
  export type Output = void;

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof tasksV1CardsResetScoreCreate> {
    return {
      uuid: input.taskId,
      resetScoreViewInputRequest: {
        reason: resetReasonMapper(input.reason),
        description: input.description,
      },
    };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        await ok(tasksV1CardsResetScoreCreate(body, opts));
        return;
      },
    });
  }
}
